<script>
  import Header from "../../../lib/components/Header.svelte";
  import ButtonNew from "../../../lib/components/ButtonNew.svelte";
  import { Accordion, SectionWrapper } from "paxray-components-svelte";
  import SideKpi from "../../../lib/components/sideKPI.svelte";

  // to be replaced

  import { DataTable } from "carbon-components-svelte";

  //// data for table (main)

  let headers = [
    { key: "name", value: "Name" },
    { key: "status", value: "Status" },
  ];

  let rows = [
    {
      id: "a",
      name: "Project Lorem ipsum dolor sit amet 1",
      status: "Online",
      lastPing: "42", // timestamp last ping
      recorderVersion: "42", // recorder version
      dateConfig: "42", // timestamp config
      logURL: "/", // download-url for error-log
    },
    {
      id: "b",
      name: "Project Lorem ipsum dolor sit amet 2",
      status: "Online",
      lastPing: "43",
      recorderVersion: "43",
      dateConfig: "43",
      logURL: "/",
    },
    {
      id: "c",
      name: "Project Lorem ipsum dolor sit amet 3",
      status: "Offline",
      lastPing: "44",
      recorderVersion: "44",
      dateConfig: "43",
      logURL: "/",
    },
  ];

  //// variables for the side menu

  let nSensorsTotal = 42; // total number of sensors in the project
  let nSensorsOnline = 42; // total number of online sensors
  let dateLastEntry = new Date().toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }); // timestamp last data-entry

  let dataBaseVersion = new Date().toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
  }); // timestamp database version

  let dateLastWindowTitle = new Date().toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }); // timestamp last windowtitle-data receive

  let dateLastUiElement = new Date().toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }); // timestamp last ui-element-data receive

  let dateLastMouseClick = new Date().toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }); // timestamp last mouseclick-data receive

  let dateLastKeyStroke = new Date().toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }); // timestamp last keystroke-data receive

  // calculations

  let percentageOnline = Math.round((nSensorsOnline / nSensorsTotal) * 100);
</script>

<Header section="Sensors" breadcrumb="Overview">
  <ButtonNew
    secondary={true}
    icon="download"
    iconLeft={true}
    text="Download Logs"
  />
</Header>

<SectionWrapper>
  <div slot="main" class="main">
    <DataTable expandable {headers} {rows}>
      <svelte:fragment slot="expanded-row" let:row>
        <div class="info_wrapper">
          <ButtonNew
            secondary={true}
            setting={true}
            url={row.logURL}
            iconLeft="download"
            text="Download Log"
          />
          <div class="info">
            <div class="info_name bold">Last Ping:</div>
            <div class="info_value">{row.lastPing}</div>
          </div>
          <div class="info">
            <div class="info_name bold">Recorder Version:</div>
            <div class="info_value">{row.recorderVersion}</div>
          </div>
          <div class="info">
            <div class="info_name bold">Date of Config:</div>
            <div class="info_value">{row.dateConfig}</div>
          </div>
        </div>
      </svelte:fragment>
    </DataTable>
  </div>
  <div slot="menu" class="menu">
    <Accordion heading="General Info" open={true}>
      <div class="kpi_wrapper">
        <SideKpi name="Sensors Online" value={percentageOnline} unit="%" />
        <SideKpi name="Last Entry" value={dateLastEntry} />
      </div>
    </Accordion>
    <Accordion heading="Data Details" open={true}>
      <div class="kpi_wrapper">
        <SideKpi name="Database Version" value={dataBaseVersion} />
        <SideKpi name="Last WindowTitle" value={dateLastWindowTitle} />
        <SideKpi name="Last UI-Element" value={dateLastUiElement} />
        <SideKpi name="Last Mouseclick" value={dateLastMouseClick} />
        <SideKpi name="Last Keystroke" value={dateLastKeyStroke} />
      </div>
    </Accordion>
  </div>
</SectionWrapper>

<style>
  .main {
    min-width: 100%;
    width: 100%;
  }

  .menu {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .kpi_wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .info_wrapper {
    display: flex;
    align-items: center;
    gap: 1.6rem;
    height: 4rem;
  }

  .info {
    height: 3rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
</style>
